import { createContext, useContext } from 'react'

/**
 * Going from one record to another it is linked to.
 *
 * The shell owns where you are, so it owns the jump and the single step back.
 * Anything deep in the tree — a Links list inside a sheet, say — reaches it
 * through here rather than by threading a callback down five levels.
 *
 * Call it as jumpTo({ type, id }, from) where `from` optionally names the
 * record you are leaving, so Back can re-open it rather than only returning
 * to the screen it was on.
 */
export const JumpContext = createContext(null)

export function useJump() {
  return useContext(JumpContext)
}
